import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import LandingPage from "pages/landing-page";
import WISPage from "pages/wis-page";
import PricingPage from "pages/pricing-page";
import ServicesPage from "pages/services-page";
import ContactPage from "pages/contact-page";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your routes here */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/landing-page" element={<LandingPage />} />
        <Route path="/wis-page" element={<WISPage />} />
        <Route path="/pricing-page" element={<PricingPage />} />
        <Route path="/services-page" element={<ServicesPage />} />
        <Route path="/contact-page" element={<ContactPage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;